export default __webpack_public_path__ + "static/6-fitness-0d4e931b915b0017d8d7a65074018477.png";